<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
    data() {
        return {
            changeColor: '#0866b4' // 后台返回的色值
        }
    },
    computed: {
        colorProps() {
           return {
               'moveColor': this.changeColor
           }
        }
    }
}
</script>
<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

body {
  box-sizing: border-box;
  --themeColor: #396EE5;
}
#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
// 轮播banner
.carousel {
  position: absolute;
  // left: 0;
  // top: 0;
  width: 100%;
}
.ban_l {
  // flex: 1;
  // margin-top: 88px;
  z-index: 99;
  text-align: left;
  width: 70%;
  .tit {
      font-weight: 900;
      font-size: 40px;
      margin-bottom: 1%;
  }
  .desc {
      font-size: 14px;
      color: #7a8ba4;
      -webkit-line-clamp: 4;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
  }
}
.disable_class{
  background: #efefef;
  color: #999;
  border-radius: 8px;
  padding: 6px 8px;
  cursor:not-allowed;
  text-align: center;
}
</style>
